import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note22',
  templateUrl: './note22.component.html',
  styleUrls: ['./note22.component.scss'],
})
export class Note22Component implements OnInit {
  note22Form: FormGroup;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (
        data.noteId === Notes.Note22 &&
        data.response.userInputData !== null &&
        data.response.userInputData !== undefined &&
        data.response.userInputData.data !== null &&
        data.response.userInputData.data !== undefined
      ) {
        this.editNotes22(data.response.userInputData.data);
      }
    });
  }

  editNotes22(res): void {
    this.note22Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
      textbox2: res.textbox2 ? res.textbox2 : ' ',
      textbox3: res.textbox3 ? res.textbox3 : ' ',
    });
  }

  setForm(): void {
    this.note22Form = new FormGroup({
      textbox1: new FormControl(''),
      textbox2: new FormControl(''),
      textbox3: new FormControl(''),
    });
  }
}
